import { defineStore } from 'pinia';
import Network from "~/utils/network";

const urls = {
    fieldWithId: (id) => `/administration/field/${id}`,
};

export const useSimpleFieldStore = defineStore('simpleField', {
    state: () => ({
        fieldData: {},
    }),
    actions: {
        fetchOne: async function (id) {
            try {
                const self = this;
                await Network.http(urls.fieldWithId(id)).then(
                    function (data) {self.saveOne(data);}
                );
            } catch (err) {
                console.log(err);
                await Promise.reject(err);
            }
        },
        saveOne: function (data) {
            this.fieldData[data.id] = data;
        },
    },
});
